import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=4c437da4&scoped=true&"
import script from "./ListNotifications.vue?vue&type=script&lang=js&"
export * from "./ListNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ListNotifications.vue?vue&type=style&index=0&id=4c437da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c437da4",
  null
  
)

export default component.exports